<template>
  <div class="flex items-center">
    <span @click="openEditEvent(params.data)" class="text-inherit font-bold hover:text-primary cursor-pointer" v-if="showR">{{ params.value }}</span>
    <span class="font-normal cursor-auto" v-if="!showR">{{ params.value }}</span> <!--crud-->

    <!-- EDIT EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="Edit Reservation"
        accept-text= "Submit"
        cancel-text = "Cancel"
        button-cancel = "border"
        @accept="addEvent(eventId)"
        :is-valid="validForm"
        :active.sync="activePromptEditEvent">

        <div class="mt-4" v-if="this.data_local.is_block === 0">
          <label class="vs-input--label">Unit*</label>
          <v-select :options="optionUnit" :reduce="number => number.id" label="number" v-validate="'required'" v-model="data_local.unit_id" name="unit_id" class="inputx" @change="loadUser" @input="loadUser()"/>
          <span class="text-danger text-sm"  v-show="errors.has('unit_id')">{{ errors.first('unit_id') }}</span>
        </div>

        <div class="mt-4" v-if="roleVal == 'admin' && this.data_local.is_block === 0">
          <label class="vs-input--label">Resident*</label>
          <v-select :options="optionUser" :reduce="email => email.id" label="email" v-validate="'required'" v-model="data_local.user_id" name="user_id" class="inputx"/>
          <span class="text-danger text-sm"  v-show="errors.has('user_id')">{{ errors.first('user_id') }}</span>
        </div>

        <div class="mt-4" v-if="roleVal !== 'admin'">
          <label class="vs-input--label">Resident*</label>
          <vs-input name="user_full_name" class="w-full" v-model="user_full_name" type="text" disabled></vs-input>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Amenity*</label>
          <v-select :options="optionAmenity" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.amenity_id" name="amenity_id" class="inputx" @change="selectAmenity" @input="selectAmenity()"/>
          <span class="text-danger text-sm"  v-show="errors.has('amenity_id')">{{ errors.first('amenity_id') }}</span>
        </div>

        <div class="mt-4">
          <small class="date-label">Reservation Start Date</small>
          <flat-pickr :config="configETA" v-model="data_local.startDate" :placeholder="data_local.startDate" :class="{'mr-2':true, 'mb-2':true, 'flatpickr-input':true, 'w-full':true, 'cursor-not-allowed':data_local.amenity_id==null }" @on-change="onFromChange" :disabled="data_local.amenity_id==null"/>
        </div>

        <div class="mt-4">
          <small class="date-label">Reservation End Date</small>
          <flat-pickr :config="configETA" v-model="data_local.endDate" :placeholder="data_local.endDate" :class="{'mr-2':true, 'mb-2':true, 'flatpickr-input':true, 'w-full':true, 'cursor-not-allowed':data_local.amenity_id==null }" @on-change="onFromChange" :disabled="data_local.amenity_id==null"/>
        </div>

        <div class="vx-row">
          <div class="mt-4 vx-col w-1/2">
            <small class="date-label">Start Time</small>
            <v-select :options="optionHoursStart" :reduce="val => val.id" label="val" v-validate="'required'" v-model="data_local.from_time" name="from_time" class="inputx" @change="selectAmenity2" @input="selectAmenity2()" :disabled="data_local.amenity_id==null"/>
            <span class="text-danger text-sm" v-show="errors.has('from_time')">{{ errors.first('from_time') }}</span>
          </div>

          <div class="mt-4 vx-col w-1/2">
            <small class="date-label">End Time</small>
            <v-select :options="optionHoursEnd" :reduce="val => val.id" label="val" v-validate="'required'" v-model="data_local.to_time" name="to_time" class="inputx" :disabled="data_local.amenity_id==null"/>
            <span class="text-danger text-sm" v-show="errors.has('to_time')">{{ errors.first('to_time') }}</span>
          </div>
        </div>


        <div class="mt-4" v-if="this.data_local.is_block === 0">
          <label class="vs-input--label">Expected No of People</label>
          <vs-input name="people" class="w-full" v-model="data_local.people" type="number"></vs-input>
          <span class="text-danger text-sm"  v-show="errors.has('people')">{{ errors.first('people') }}</span>
        </div>

        <div class="mt-4 vx-col" v-if="this.data_local.is_block === 0 && roleVal == 'admin'">
          <label class="vs-input--label text-success" style="font-weight:bold">Action</label>
          <v-select :options="optionAction" :reduce="name => name.val" label="name" v-model="data_local.label" name="label" class="inputx"/>
          <span class="text-danger text-sm" v-show="errors.has('label')">{{ errors.first('label') }}</span>
        </div>

        <div class="mt-6" v-if="this.data_local.label === 'reject'">
          <vs-textarea height="50px" class="w-full mt-4" label="Reject Reason" v-model="data_local.rejection_reason" type="text" name="rejection_reason" />
          <span class="text-danger text-sm"  v-show="errors.has('rejection_reason')">{{ errors.first('rejection_reason') }}</span>
        </div>

        <div class="mt-6" v-if="this.data_local.is_block === 0">
          <vs-textarea height="50px" class="w-full mt-4" label="Resident Comments" v-model="data_local.comments" type="text" name="comments" />
          <span class="text-danger text-sm"  v-show="errors.has('comments')">{{ errors.first('comments') }}</span>
        </div>

        <div class="mt-4" v-if="this.data_local.is_block === 0 && roleVal == 'admin'">
          <vs-textarea height="50px" class="w-full mt-4" label="Internal Comments" v-model="data_local.internal_comments" type="text" name="internal_comments" />
          <span class="text-danger text-sm"  v-show="errors.has('internal_comments')">{{ errors.first('internal_comments') }}</span>
        </div>

        <div class="mt-4" v-if="this.data_local.is_block === 1">
          <vs-textarea height="50px" class="w-full mt-4" label="Block Reason" v-model="data_local.block_reason" type="text" name="block_reason" />
          <span class="text-danger text-sm"  v-show="errors.has('block_reason')">{{ errors.first('block_reason') }}</span>
        </div>

    </vs-prompt>
  </div>
</template>

<script>
import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud
import common from '@/common'
import EditEventMixin from '../../edit-event-mixin'

const jwt = require('jsonwebtoken')
const token = localStorage.usertoken
const decoded = jwt.verify(token, 'secret')
const tz = 0 //new Date().getTimezoneOffset() / -60;
const tx = new Date().getTimezoneOffset() / -60

export default {
  name: 'CellRendererEditModal',
  mixins: [EditEventMixin],
  data () {
    return {
      // crud
      showR: false,
      token: localStorage.usertoken
    }
  },
  computed: {
    validForm () {
      const user_id = this.roleVal === 'admin' ? this.data_local.user_id : decoded.id
      return this.from_datetime !== '' && Date.parse(this.data_local.endDate) - Date.parse(this.data_local.startDate) >= 0 && this.data_local.unit_id !== null && user_id !== null && this.data_local.amenity_id !== null && this.data_local.amenity_id !== null && this.data_local.from_time !== null && this.data_local.to_time !== null
    }
  },
  methods: {
    async openEditEvent (event) {
      if (this.roleVal !== 'admin' && decoded.id !== event['user_id']) {
        this.$vs.notify({
          color: 'danger',
          title: 'Data Edit',
          text: 'You are not allowed'
        })
        return
      }

      this.data_local.is_block = event['is_block']
      this.data_local.unit_id = event['unit_id']
      await this.loadUser()

      const sts = common.subtractHours(new Date(event['startDate']), tx)
      const ste = common.subtractHours(new Date(event['endDate']), tx)
      // this.data_local.startDate = sts
      this.data_local.startDate = common.formatDate(sts)
      this.data_local.amenity_id = event['amenity_id']
      await this.selectAmenity()

      // this.data_local.startDate = sts
      this.data_local.startDate = common.formatDate(sts)
      this.data_local.to_time = event['to_time']
      this.data_local.from_time = event['from_time']
      this.data_local.from_date = event['from_date']
      this.data_local.to_date = event['to_date']
      // this.data_local.endDate = ste
      this.data_local.endDate = common.formatDate(ste)
      this.data_local.title = event['title']
      this.data_local.label = event['label']
      this.data_local.classes = event['classes']
      this.optionHour.filter((res) => {
        this.data_local.from_time = this.data_local.from_time === res['val'] ? res['id'] : this.data_local.from_time
      })

      await this.selectAmenity2()
      this.data_local.from_time = event['from_time']
      this.data_local.to_time = event['to_time']
      this.eventId = event['id']
      this.data_local.unit_resident_id = event['unit_resident_id']
      this.data_local.people = event['people']
      this.data_local.comments = event['comments']
      this.data_local.status = event['status']
      this.data_local.user_id = event['user_id']
      this.data_local.is_seen = event['is_seen']
      this.data_local.property_id = event['property_id']
      this.data_local.rejection_reason = event['rejection_reason']
      this.data_local.internal_comments = event['internal_comments']
      this.data_local.block_reason = event['block_reason']
      this.activePromptEditEvent = true
    },
    async addEvent (eid) {
      try {
        this.data_local.property_ref = localStorage.selectedParentOrgRef
        this.optionAmenity.filter((res) => {
          this.amenity_name = this.data_local.amenity_id === res['id'] ? res['name'] : this.amenity_name
        })

        this.optionUnit.filter((res) => {
          this.unit_number = this.data_local.unit_id === res['id'] ? res['number'] : this.unit_number
        })

        this.optionHour.filter((res) => {
          this.data_local.from_time = this.data_local.from_time === res['id'] ? res['val'] : this.data_local.from_time

          this.data_local.to_time = this.data_local.to_time === res['id'] ? res['val'] : this.data_local.to_time
        })

        // this.data_local.endDate = this.data_local.is_block === 0 ? this.data_local.startDate : this.data_local.endDate

        const sdt = common.convertT(this.data_local.from_time, common.formatDate(new Date(this.data_local.startDate)))
        const edt = common.convertT(this.data_local.to_time, common.formatDate(new Date(this.data_local.endDate)))

        this.data_local.startDate = common.addHours(new Date(sdt), tz)
        this.data_local.endDate = common.addHours(new Date(edt), tz)

        this.data_local.title = `${this.amenity_name  }: ${  this.unit_number  } - (${  this.data_local.from_time  } to ${  this.data_local.to_time  })`
        this.data_local.classes = `event-${  this.labelColor(this.data_local.label)}`
        this.data_local.from_datetime = common.addHours(new Date(sdt), tz)
        this.data_local.to_datetime = common.addHours(new Date(edt), tz)
        this.data_local.from_date = common.formatDate2(sdt)
        this.data_local.to_date = common.formatDate2(edt)
        this.data_local.createdAt = common.addHours(new Date(), tz)
        this.data_local.updatedAt = common.addHours(new Date(), tz)

        let y = 0
        let tempSdt = null
        this.data_local.from_dates = []

        for (let i = new Date(this.data_local.from_date).getDay(); i <= (new Date(this.data_local.to_date).getDay()); i++) {
          tempSdt = common.addDays(this.data_local.from_date, y)
          this.data_local.from_dates.push(tempSdt)
          y++
        }

        const amenityResDup = await axios.get('/amenity-reservation-detail/dup', {
          headers: {
            'Authorization': localStorage.usertoken,
            'property_ref': localStorage.selectedParentOrgRef,
            'amenity_id': this.data_local.amenity_id,
            'from_dates': JSON.stringify(this.data_local.from_dates)
          }
        })

        this.timeS = false
        amenityResDup['data']['AmenityReservationF'].filter((res) => {

          const cTs = common.convertT(res['from_time'], res['from_date'])
          const cTe = common.convertT(res['to_time'], res['to_date'])
          const cTls = common.convertT(this.data_local.from_time, common.formatDate(new Date(this.data_local.startDate)))
          const cTle = common.convertT(this.data_local.to_time, common.formatDate(new Date(this.data_local.endDate)))

          if (parseInt(eid) !== parseInt(res['amenity_reservation_id'])) {
            for (let i = cTs.getHours(); i <= (cTe.getHours() - 1); i++) {
              this.timeS = cTls.getHours() === i ? true : this.timeS
              this.timeS = cTle.getHours() - 1 === i ? true : this.timeS
            }
          }

          if (parseInt(eid) !== parseInt(res['amenity_reservation_id'])) {
            for (let i = cTls.getHours(); i <= (cTle.getHours() - 1); i++) {
              this.timeS = cTs.getHours() === i ? true : this.timeS
              this.timeS = cTe.getHours() - 1 === i ? true : this.timeS
            }
          }

        })

        if (this.timeS) {
          this.$vs.notify({
            color: 'danger',
            title: 'Data Saved',
            text: 'Time slot not available'
          })
          return
        }

        const res = await axios.post(`/amenity-reservation/save/${eid}`, {
          data: this.data_local,
          token: this.token
        })

        //delete amenity-reservation-detail
        await axios.post(`/amenity-reservation-detail/delete/${eid}`, {
          token: this.token
        })
        //delete amenity-reservation-detail

        //save amenity-reservation-detail
        if (this.data_local.label === 'approve' || this.data_local.label === 'pending') {
          this.data_local.amenity_reservation_id = eid === -1 ? res['data']['arRes']['id'] : eid
          await axios.post('/amenity-reservation-detail/save/-1', {
            data: this.data_local,
            token: this.token
          })
        }
        //save amenity-reservation-detail

        if (res['data'] !== 'access_denied' && res['data'] !== '') {
          this.$vs.notify({
            color: 'success',
            title: 'Data Saved',
            text: 'The selected data was successfully saved'
          })
          this.params.context.componentParent.loadList()
        }  else {
          throw new TypeError('Something went wrong')
        }
      } catch (err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Data Saving Error',
          text: err.toString('utf8')
        })
      }

      // const obj = { title: this.title, startDate: this.data_local.from_date, endDate: this.data_local.to_date, label: this.labelLocal, url: this.url }
      // obj.classes = `event-${  this.labelColor(this.labelLocal)}`
      // this.$store.dispatch('calendar/addEvent', obj)
    }
  },
  async created () {
    // crud
    this.showR = await mainHelper.cansee('amenity-read', 'read')
  }
}
</script>
